export const roomConstants = {
    ROOM_REQUEST: 'ROOM_REQUEST',
    ROOM_SUCCESS: 'ROOM_SUCCESS',
    ROOM_FAILURE: 'ROOM_FAILURE',

    ROOM_WAIT_USER: 'ROOM_WAIT_USER',
    ROOM_STOP_WAITING_USER: 'ROOM_STOP_WAITING_USER',

    CREATE_ROOM_REQUEST: 'CREATE_ROOM_REQUEST',
    CREATE_ROOM_SUCCESS: 'CREATE_ROOM_SUCCESS',
    CREATE_ROOM_FAILURE: 'CREATE_ROOM_FAILURE',

    JOIN_ROOM_REQUEST: 'JOIN_ROOM_REQUEST',
    JOIN_ROOM_SUCCESS: 'JOIN_ROOM_SUCCESS',
    JOIN_ROOM_FAILURE: 'JOIN_ROOM_FAILURE',

    LEAVE_ROOM_REQUEST: 'LEAVE_ROOM_REQUEST',
    LEAVE_ROOM_SUCCESS: 'LEAVE_ROOM_SUCCESS',
    LEAVE_ROOM_FAILURE: 'LEAVE_ROOM_FAILURE',
}